import {persianCopy} from './persianTranslations.js';
export const announcementCopy = {
  "tr": [
    "Yönetimden duyurular, güncellemeler ve bilgilendirmeler.",
    "Henüz yayımlanmış duyuru yok.",
    "Yeni duyurular burada yer alacak."
  ],
  "en": [
    "Announcements, updates and information from the administration.",
    "No announcements have been published yet.",
    "New announcements will appear here."
  ],
  "de": [
    "Ankündigungen, Neuigkeiten und Informationen der Verwaltung.",
    "Noch keine Ankündigungen veröffentlicht.",
    "Neue Ankündigungen erscheinen hier."
  ],
  "ar": [
    "إعلانات وتحديثات ومعلومات من الإدارة.",
    "لا توجد إعلانات منشورة حتى الآن.",
    "ستظهر الإعلانات الجديدة هنا."
  ],
  "fr": [
    "Annonces, mises à jour et informations de l’administration.",
    "Aucune annonce publiée pour le moment.",
    "Les nouvelles annonces apparaîtront ici."
  ],
  "es": [
    "Anuncios, novedades e información de la administración.",
    "Todavía no hay anuncios publicados.",
    "Los nuevos anuncios aparecerán aquí."
  ],
  "ru": [
    "Объявления, обновления и информация от администрации.",
    "Опубликованных объявлений пока нет.",
    "Новые объявления появятся здесь."
  ],
  "zh": [
    "管理方发布的公告、更新与资讯。",
    "暂无已发布的公告。",
    "新公告将在此显示。"
  ]
};

announcementCopy.fa=persianCopy(announcementCopy.tr);

const stateCopy={tr:['Duyurular yükleniyor…','Duyurular alınamadı. Sayfayı yeniden yükleyin.'],en:['Loading announcements…','Could not load announcements. Reload the page.'],de:['Mitteilungen werden geladen…','Mitteilungen konnten nicht geladen werden. Seite neu laden.'],ar:['جارٍ تحميل الإعلانات…','تعذر تحميل الإعلانات. أعد تحميل الصفحة.'],fr:['Chargement des annonces…','Impossible de charger les annonces. Rechargez la page.'],es:['Cargando anuncios…','No se pudieron cargar los anuncios. Recarga la página.'],ru:['Загрузка объявлений…','Не удалось загрузить объявления. Обновите страницу.'],zh:['正在加载公告…','无法加载公告。请刷新页面。'],fa:['در حال بارگذاری اطلاعیه‌ها…','بارگذاری اطلاعیه‌ها انجام نشد. صفحه را دوباره بارگذاری کنید.']};
for(const [locale,copy]of Object.entries(stateCopy))announcementCopy[locale].push(...copy);
